import React from "react";
import { Box, Button, Text } from "grommet";

import useBook from "../../hooks/useBook";

import ArchiveCanvas from "../../shared_comp/ArchiveCanvas";
import SectionTitle from "../../shared_comp/SectionTitle";
import ContentCanvas from "../../shared_comp/ContentCanvas";
import MainCanvas from "../../shared_comp/MainCanvas";
import { Book } from "grommet-icons";
import GazetteBook from "./GazetteBook";
import {
    BsChevronBarContract,
    BsChevronBarExpand,
    BsChevronContract,
    BsChevronExpand,
} from "react-icons/bs";
import GazetteYearMonth from "./GazetteYearMonth";

const GazetteMain = () => {
    // Step1 - recevie total books
    const [bookList, setBookList] = React.useState<any>([]);
    React.useEffect(() => {
        const receiveData = async () => {
            const res = await useBook.getBookList("dobo");
            setBookList(res.books);
        };
        receiveData();
    }, []);

    // Step2 - divide books by year and year-month
    const [yearBooks, setYearBooks] = React.useState<any>({});
    const [yearMonthBooks, setYearMonthBooks] = React.useState<any>({});
    React.useEffect(() => {
        if (bookList.length > 0) {
            let yearBooks: { [key: string]: string[] } = {};
            let yearMonthBooks: { [key: string]: string[] } = {};
            //add month, day info from dividing publish_date by '年,月,日'
            bookList.forEach((b: any) => {
                let date_div = b.publish_date.split("年");
                let year = date_div[0];
                let month = parseInt(date_div[1].split("月")[0]);
                let day = parseInt(date_div[1].split("月")[1].split("日")[0]);
                b.publish_month = month;
                b.publish_day = day;
            });
            let books_sorted = bookList.sort((a: any, b: any) => {
                if (a.publish_month > b.publish_month) {
                    return 1;
                } else if (a.publish_month < b.publish_month) {
                    return -1;
                } else {
                    if (a.publish_day > b.publish_day) {
                        return 1;
                    } else if (a.publish_day < b.publish_day) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            });
            // add book data to ymBooks
            books_sorted.forEach((b: any) => {
                let year = b.publish_year;
                let month = parseInt(b.publish_month);
                let ym = year + "-" + month;
                if (month < 10) {
                    ym = year + "-0" + month;
                }
                if (year in yearBooks) {
                    yearBooks[year].push(b);
                } else {
                    yearBooks[year] = [b];
                }
                if (ym in yearMonthBooks) {
                    yearMonthBooks[ym].push(b);
                } else {
                    yearMonthBooks[ym] = [b];
                }
            });
            setYearBooks(yearBooks);
            setYearMonthBooks(yearMonthBooks);
        }
    }, [bookList]);
    // console.log(yearBooks);

    // Step3 - make calendar
    const [yearSelected, setYearSelected] = React.useState<any>(1911);
    const Calendar = () => {
        const AYear = (props: any) => {
            const { year } = props;
            return (
                <Box
                    direction="row"
                    align="center"
                    justify="center"
                    focusIndicator={false}
                    hoverIndicator={year in yearBooks ? true : false}
                    style={{
                        cursor: year in yearBooks ? "pointer" : "default",
                    }}
                    onClick={() => {
                        year in yearBooks && setYearSelected(year);
                    }}
                >
                    <Text
                        size="14px"
                        margin="5px"
                        color={
                            year in yearBooks
                                ? "rgb(255,255,255,1)"
                                : "rgb(255,255,255,0.3)"
                        }
                    >
                        {year}
                    </Text>
                </Box>
            );
        };
        const Years = (props: any) => {
            const { years } = props;
            return (
                <Box direction="row" align="center" justify="center">
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((v) => {
                        return <AYear year={1900 + years + v} />;
                    })}
                </Box>
            );
        };
        return (
            <Box width="full" align="center" justify="center" height="300px">
                <Box direction="row" align="center" justify="center">
                    <Text size="17px" color="white" margin="10px">
                        경기도보
                    </Text>
                    <Text size="14px" color="white">
                        京畿道報
                    </Text>
                </Box>
                <Box direction="column">
                    {[10, 20, 30, 40].map((v) => {
                        return <Years years={v} key={v}/>;
                    })}
                </Box>
            </Box>
        );
    };

    const YearSelect = () => {
        return (
            <Box
                height="80px"
                align="center"
                justify="center"
                margin={{ top: "20px" }}
                direction="column"
            >
                <Box align="center" justify="center">
                    <Text size="18px" color="white">
                        {yearSelected}
                    </Text>
                </Box>
            </Box>
        );
    };

    // Step4 - select month
    const MonthSelectInYear = () => {
        const [monthList, setMonthList] = React.useState<any>([]);
        const [monthSelected, setMonthSelected] = React.useState<any>("01");

        let months: any[] = [];
        for (let i = 1; i < 13; i++) {
            let m_text = i.toString();
            if (i < 10) {
                m_text = "0" + m_text;
            }
            months.push([i, m_text]);
        }

        React.useEffect(() => {
            if (yearSelected in yearBooks) {
                let months: any[] = [];
                yearBooks[yearSelected].forEach((b: any) => {
                    if (months.indexOf(b.publish_month) < 0) {
                        months.push(b.publish_month);
                    }
                });
                console.log("year-month n", yearSelected, months);
                setMonthList(months);
                let month_start = months[0].toString();
                if (month_start < 10) {
                    month_start = "0" + months[0].toString();
                }
                setMonthSelected(month_start);
            }
        }, [yearSelected]);

        const [ym, setYm] = React.useState<any>(null);

        React.useEffect(() => {
            let year_month = yearSelected + "-" + monthSelected;
            setYm(year_month);
            console.log("year-month", year_month, ym);
        }, [monthSelected]);

        React.useEffect(() => {
            console.log("ym", ym);
        }, [ym]);

        const MonthButton = (props: any) => {
            let { month } = props;

            return (
                <>
                    {monthList.includes(month[0]) ? (
                        <Button
                            plain
                            key={month[0]}
                            label={
                                <Text
                                    size={
                                        month[1] === monthSelected
                                            ? "18px"
                                            : "15px"
                                    }
                                    weight={
                                        month[1] === monthSelected
                                            ? "bold"
                                            : "normal"
                                    }
                                >
                                    {month[0]}
                                </Text>
                            }
                            color={
                                month[1] === monthSelected ? "indigo" : "black"
                            }
                            margin="5px"
                            onClick={() => {
                                setMonthSelected(month[1]);
                                console.log("month", month[1]);
                            }}
                        ></Button>
                    ) : (
                        <Button
                            plain
                            key={month[0]}
                            disabled
                            label={
                                <Text size="15px" color="grey">
                                    {month[0]}
                                </Text>
                            }
                            color="grey"
                            margin="5px"
                        />
                    )}
                </>
            );
        };

        return (
            <Box
                background="rgba(255,255,255,0.8)"
                width="full" height="full">
                <Box
                    height="60px"
                    direction="row"
                    align="center"
                    justify="center"
                    background={"rgba(255,255,255,0.8)"}
                >
                    {months.map((m) => {
                        return <MonthButton month={m} />;
                    })}
                </Box>
                <Box
                    width="full"
                    height="full"
                    pad='20px'
                    direction="column"
                >
                    <GazetteYearMonth
                        books={ym in yearMonthBooks ? yearMonthBooks[ym] : []}
                        yrmo={ym}
                    />
                </Box>
            </Box>
        );
    };

    return (
        <ArchiveCanvas>
            <SectionTitle title="정부자료 / 서임급사령" />
            <MainCanvas>
                <Box
                    direction="column"
                    align="center"
                    justify="start"
                    width="full"
                    height="full"
                >
                    <Calendar />
                    <YearSelect />
                    <MonthSelectInYear />
                </Box>
            </MainCanvas>
        </ArchiveCanvas>
    );
};
export default GazetteMain;
